function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.7478 5.28683C10.7478 5.42913 10.6975 5.56306 10.5971 5.6635L6.0519 10.2087C5.95145 10.3092 5.80915 10.3677 5.66685 10.3677C5.53292 10.3677 5.39063 10.3092 5.29018 10.2087L2.26004 7.17857C2.1596 7.07812 2.10938 6.9442 2.10938 6.8019C2.10938 6.6596 2.1596 6.5173 2.26004 6.41685L3.02176 5.6635C3.12221 5.56306 3.25614 5.50446 3.39844 5.50446C3.54074 5.50446 3.67467 5.56306 3.77511 5.6635L5.66685 7.55525L9.08203 4.14844C9.18248 4.04799 9.31641 3.9894 9.45871 3.9894C9.601 3.9894 9.73493 4.04799 9.83538 4.14844L10.5971 4.90179C10.6975 5.00223 10.7478 5.14453 10.7478 5.28683ZM12.8571 6.64286C12.8571 3.09375 9.97768 0.214285 6.42857 0.214285C2.87946 0.214285 0 3.09375 0 6.64286C0 10.192 2.87946 13.0714 6.42857 13.0714C9.97768 13.0714 12.8571 10.192 12.8571 6.64286Z",
  fill: "currentColor"
});

var SvgCheck = function SvgCheck(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 13 14",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCheck, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/check.d2e3d8c3.svg";
export { ForwardRef as ReactComponent };